import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const DevelopmentOptionsWrapper = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['16px']};
    `
);

export const DevelopmentOptionsContainer = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        padding-top: ${spacing['16px']};
        padding-bottom: ${spacing['32px']};

        ${mq.small} {
            display: flex;
        }

        li > svg {
            flex-shrink: 0;
            margin: 0;
        }
    `
);

export const List = styled('ul')(
    ({ theme: { mq, spacing } }) => css`
        flex-wrap: wrap;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style-type: none;

        &:last-of-type {
            padding-top: ${spacing['24px']};
        }

        ${mq.small} {
            width: 50%;
        }
    `
);

export const ListItem = styled('li')(
    ({ theme: { spacing, colors } }) => css`
        display: flex;
        padding: ${spacing['8px']} 0;
        color: ${colors['text-body']};
        width: 100%;
        margin-right: 0;
    `
);

export const Name = styled('span')(
    ({ theme: { spacing } }) => css`
        margin-left: ${spacing['16px']};
        flex-grow: 1;
    `
);
